import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
//pages
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ClientOnboarding from "./pages/ClientOnboarding";
import ClientOnboardingSections from "./pages/ClientOnboarding/ClientOnboardingForms";
import LoginLayout from "./layout/LoginLayout";
import AdminLayout from "./layout/AdminLayout";
import Layout from "./layout/LayoutWithSidebar";
import EmployeeOnboarding from "./pages/EmployeeOnboarding";
import SetAuth from "./pages/SetAuth";
import EmployeeOnboardingSections from "./pages/EmployeeOnboarding/EmployeeOnboardingForms";
import Offerletter from "./pages/Offerletter";
import DashBoard from "./pages/Dashboard";
import "./App.scss";
import CompanySettings from "./pages/CompanySettings";
import Logout from "./layout/Logout";
import Profile from "./pages/Profile";
import Signatory from "./pages/Signatory";
import EmployerStateTax from "./pages/EmployerStateTax";
import Payroll from "./pages/Payroll";
import NotFound from "./layout/NotFound";
import SignDocuments from "./pages/SignDocuments";
import SignDocumentsDetails from "./components/SignDocumentDetails";
import EmployeeStatus from "./pages/EmployeeStatus";
import Settings from "./pages/Settings";
import IFrame from "./components/iframe";
import TwoFactorPage from "./pages/TwoFactorAuthentication";
import EmployeeTwoFactorAuthPage from "./pages/TwoFactorAuthEmployee";
import MobileVerificationPage from "./pages/TwoFactorAuthEmployee/MobileVerifications.js";
import OtpVerificationPage from "./pages/OtpVerification/index.js";
import OtpSuccess from "./pages/OtpSuccess/index.js";
import TimeCardsPage from "./pages/timeCards";
import PayPeriodSummaryPage from "./pages/payPeriodSummary";
import TimeOffCalenderPage from "./pages/TimeOffCalender";
import TimeOffCardsPage from "./pages/timeOffCards";
import MultiCardApprovalPage from "./pages/MultiCardApproval";
import MultiCardDetailPage from "./pages/MultiCardDetail";
import CustomReport from "./pages/customReport/index.js";
import Reports from "./pages/reports";
import ReportsDetailPage from "./pages/reportsDetail";
import ReportsCSVDownload from "./pages/ReportsCSVFilter/index.js";
import ClientGustoForms from "./pages/ClientGustoOnboarding/ClientOnboardingForms";
import ClientGustoOnboarding from "./pages/ClientGustoOnboarding";
import ClientGustoSummary from "./pages/ClientGustoSummary";
import EmployeeSignDocument from "./pages/EmployeeOnboarding/EmployeeOnboardingForms/SignDocumentDetails";
import EmployeeList from "./pages/EmployeeList";
import Iframe from "./pages/iframe";
import EmployeeCustomPdf from "./pages/EmployeeOnboarding/EmployeeOnboardingForms/EmployeeCustomPdf";
import TaskCustomPdf from "./pages/Profile/Tasks/TaskCustomPdf";
import DebitFilterReports from "./pages/DebitFilterReport/index.js";
import PayrollReportFilter from "./pages/PayrollReportFilter";
import PayrollPreview from "./pages/PayrollPreview";
import ContractorOnboarding from "./pages/ContractorOnboarding/index.js";
import ContractorOnboardingForms from "./pages/ContractorOnboarding/ContractorOnboardingForms/index.js";
import ResellerDashboard from "./pages/ResellerDashboard";
import HistoricalPayroll from "./pages/HistoricalPayroll";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" exact={true} element={<LoginLayout />}>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" exact={true} element={<Login />} />
            <Route
              path="/forgot-password"
              exact={true}
              element={<ForgotPassword />}
            />
            <Route
              path="/reset-password/:id"
              exact={true}
              element={<ResetPassword />}
            />

            <Route
              path="/client-onboard/:id"
              exact={true}
              element={<ClientOnboarding />}
            />
            <Route
              path="/employee-onboard/:id"
              exact={true}
              element={<EmployeeOnboarding />}
            />
            <Route
              path="/contractor-onboard/:id"
              exact={true}
              element={<ContractorOnboarding />}
            />
          </Route>
          <Route path="/" exact={true} element={<AdminLayout />}>
            <Route
              path="/client-onboard-sections"
              exact={true}
              element={<ClientOnboardingSections />}
            />
            <Route
              path="/client-gusto-onboard-sections"
              exact={true}
              element={<ClientGustoOnboarding />}
            />
            <Route
              path="/client-gusto-onboard-forms"
              exact={true}
              element={<ClientGustoForms />}
            />
            <Route
              path="/client-gusto-summary"
              exact={true}
              element={<ClientGustoSummary />}
            />
            <Route
              path="/employee-onboard-sections"
              exact={true}
              element={<EmployeeOnboardingSections />}
            />
            <Route
              path="/contractor-onboard-sections"
              exact={true}
              element={<ContractorOnboardingForms />}
            />
            <Route
              path="/offer-letter"
              exact={true}
              element={<Offerletter />}
            />
            <Route
              path="/employee-custom-pdf"
              exact={true}
              element={<EmployeeCustomPdf />}
            />
          </Route>
          <Route path="/" exact={true} element={<Layout />}>
            <Route path="/dashboard" exact={true} element={<DashBoard />} />
            <Route
              path="/company-settings"
              exact={true}
              element={<CompanySettings />}
            />
            <Route
              path="/manage-pay-schedule"
              exact={true}
              element={<IFrame />}
            />
            <Route path="/profile" exact={true} element={<Profile />} />
            <Route path="/profile/:id" exact={true} element={<Profile />} />
            <Route path="/profile/:notification" element={<Profile />} />
            <Route
              path="/profile-view-task/:id/profile/:id"
              element={<Profile />}
            />
            <Route path="/signatory" exact={true} element={<Signatory />} />
            <Route
              path="/employer-state-tax"
              exact={true}
              element={<EmployerStateTax />}
            />
            <Route path="/payroll" exact={true} element={<Payroll />} />
            <Route
              path="/sign-documents"
              exact={true}
              element={<SignDocuments />}
            />
            <Route
              path="/sign-documents-details"
              exact={true}
              element={<SignDocumentsDetails />}
            />
            <Route
              path="/sign-employee-documents-details"
              exact={true}
              element={<EmployeeSignDocument />}
            />
            <Route
              path="/employee-status"
              exact={true}
              element={<EmployeeStatus />}
            />
            <Route path="/settings" exact={true} element={<Settings />} />
            <Route
              path="/two-factor-auth"
              exact={true}
              element={<TwoFactorPage />}
            />
            <Route
              path="/timekeeping"
              exact={true}
              element={<TimeCardsPage />}
            />
            <Route
              path="/pay-period-summary"
              exact={true}
              element={<PayPeriodSummaryPage />}
            />
            <Route
              path="/time-off-calendar"
              exact={true}
              element={<TimeOffCalenderPage />}
            />
            <Route
              path="/time-off-cards"
              exact={true}
              element={<TimeOffCardsPage />}
            />
            <Route
              path="/multi-card-approval"
              exact={true}
              element={<MultiCardApprovalPage />}
            />
            <Route
              path="/multi-card-detail"
              exact={true}
              element={<MultiCardDetailPage />}
            />
            <Route
              path="/custom-report"
              exact={true}
              element={<CustomReport />}
            />
            <Route path="/reports" exact={true} element={<Reports />} />
            <Route
              path="/report-detail"
              exact={true}
              element={<ReportsDetailPage />}
            />
            <Route
              path="/report-download"
              exact={true}
              element={<ReportsCSVDownload />}
            />
            <Route
              path="/employee-deduction-list"
              exact={true}
              element={<EmployeeList />}
            />
            <Route path="/iframe" exact={true} element={<Iframe />} />
            <Route
              path="/task-custom-pdf"
              exact={true}
              element={<TaskCustomPdf />}
            />
            <Route
              path="/debit-filter-report"
              exact={true}
              element={<DebitFilterReports />}
            />
            <Route
              path="/payroll-preview"
              exact={true}
              element={<PayrollPreview />}
            />
            <Route
              path="/payroll-filter-report"
              exact={true}
              element={<PayrollReportFilter />}
            />
            <Route
              path="/reseller-dashboard"
              exact={true}
              element={<ResellerDashboard />}
            />
            <Route
              path="/historical-payroll"
              exact={true}
              element={<HistoricalPayroll />}
            />
          </Route>
          <Route path="/set-auth/:data" exact={true} element={<SetAuth />} />
          <Route
            path="/employee-two-fact-auth"
            exact={true}
            element={<EmployeeTwoFactorAuthPage />}
          />
          <Route
            path="/mobile-verification"
            exact={true}
            element={<MobileVerificationPage />}
          />
          <Route
            path="/otp-verification"
            exact={true}
            element={<OtpVerificationPage />}
          />
          <Route path="/otp-success" exact={true} element={<OtpSuccess />} />
          <Route path="/logout" exact={true} element={<Logout />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
